import { useCallback, useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import axios from "axios";
import { fadeInUp, transition } from "@/utils/motion";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  const verify = useCallback(async () => {
    if (!token) {
      setStatus("error");
      setMessage("No verification token provided.");
      return;
    }
    try {
      const res = await axios.post(`${API}/auth/verify-email`, { token });
      setStatus("success");
      setMessage(res.data.message);
    } catch (err) {
      setStatus("error");
      setMessage(err.response?.data?.detail || "Verification failed.");
    }
  }, [token]);

  useEffect(() => {
    verify();
  }, [verify]);

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="verify-page">
      <motion.div {...fadeInUp} transition={transition} className="hud-card clip-corners p-8 text-center">
        {status === "loading" && (
          <div data-testid="verify-loading">
            <Loader2 className="h-12 w-12 text-[#FFE800] mx-auto animate-spin mb-4" />
            <p className="font-data text-sm text-gray-400">Verifying your email...</p>
          </div>
        )}
        {status === "success" && (
          <div data-testid="verify-success">
            <CheckCircle className="h-12 w-12 text-green-400 mx-auto mb-4" />
            <h1 className="font-headings text-2xl uppercase tracking-widest text-green-400 mb-2">
              Email Verified
            </h1>
            <p className="text-sm text-gray-400 mb-6">{message}</p>
            <Link
              to="/login"
              className="inline-block bg-[#FFE800] text-black font-headings uppercase tracking-widest py-3 px-8 hover:bg-[#FFD700]"
              data-testid="verify-login-link"
            >
              Sign In
            </Link>
          </div>
        )}
        {status === "error" && (
          <div data-testid="verify-error">
            <XCircle className="h-12 w-12 text-red-400 mx-auto mb-4" />
            <h1 className="font-headings text-2xl uppercase tracking-widest text-red-400 mb-2">
              Verification Failed
            </h1>
            <p className="text-sm text-gray-400 mb-6">{message}</p>
            <Link
              to="/login"
              className="inline-block border border-white/20 text-white font-headings uppercase tracking-widest py-3 px-8 hover:border-[#FFE800]"
              data-testid="verify-back-link"
            >
              Back to Login
            </Link>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default VerifyEmail;
